import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useUser } from 'store'
import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'

const EMAIL_BLACKLIST = ['@economat-armees.fr']

const ExportButton = ({ onClick, analyticsName }) => {
  const [loading, setLoading] = useState()
  const { t } = useTranslation()
  const [user] = useUser()
  const location = useLocation()
  const isTopology = location.pathname.indexOf('/monitoring/topology') !== -1
  const isBlacklisted = EMAIL_BLACKLIST.some(email => user?.email?.toLowerCase().indexOf(email) > -1)

  const handleClick = async () => {
    setLoading(true)
    await onClick()
    setLoading(false)
  }

  if (isTopology || isBlacklisted) return null

  return (
    <HeaderExportButton
      analyticsName={analyticsName}
      onClick={handleClick}
      loading={loading}
      loadingLabel={t('ui_elements.in_progress')}
    >
      {t('supervision.export_button')}
    </HeaderExportButton>
  )
}

export default ExportButton
